import React, { Component } from 'react'
import { Link } from 'react-router-dom'

const nl2br = require('react-nl2br')

class ClubDetail extends Component {
    static getDerivedStateFromProps(nextProps, prevState){
        console.log('ClubDetail derived');
        if( nextProps.match.params.id !== prevState.id ){
            console.log('ClubDetail state upd');
            return {
                data: {},
                id: nextProps.match.params.id
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.state = {id:null, data:{}};
    }
    componentDidMount () {
        console.log('ClubDetail mount');
        this.load(this.props.match.params.id);
    }
    componentDidUpdate(prevProps, prevState){
        console.log('ClubDetail update');
        if( this.state.id!==prevState.id){
            this.load(this.state.id);
        }
    }
    load(id){
        console.log('ClubDetail load');
        fetch(process.env.REACT_APP_API_URL + '/get-club/id/' + id + '?key=' + process.env.REACT_APP_API_KEY).then((response) => response.json()).then((responseJson) => {
            if( !responseJson.data ){
                this.setState({id:id, data: {}});
            } else {
                this.setState({id:id, data: responseJson.data});
            }
        });
    }
    render() {
        return (
            <div className="detail-post">
                <div className="container">
                    <div className="description-post">
                    </div>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-auto" className={(this.state.data.image_url? '': 'd-none')}>
                            <div className="text-center pr-4">
                                <img src={this.state.data.image_url} className="img-fluid club-image"/>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="title-post py-4">
                                {this.state.data.name}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ClubDetail